<template>
  <v-card class="com-mb-card rw-list">
    <!-- <v-card class="rw-box-tab"> -->
    <!-- <v-tabs class="rw-tab" v-model="tab" light>
        <v-tab class="rw-tab-item">洪水予報</v-tab>
        <v-tab class="rw-tab-item">ダム放流通知</v-tab>
        <v-tab v-if="isFldCtl" class="rw-tab-item">水防警報</v-tab>
      </v-tabs> -->
    <div class="com-mb-card-contents rw-tab-btn">
      <!-- <div class="rw-tab-btn"> -->
      <v-btn
        class="rw-tab-item"
        small
        :class="rwBtnStates(0)"
        @click="clickTab(0)"
        >洪水<br />予報等</v-btn
      >
      <v-btn
        class="rw-tab-item"
        small
        :class="rwBtnStates(1)"
        @click="clickTab(1)"
        >ダム<br />放流通知</v-btn
      >
      <v-btn
        v-if="isFldCtl"
        class="rw-tab-item"
        small
        :class="rwBtnStates(2)"
        @click="clickTab(2)"
        >水防警報</v-btn
      >
      <!-- </div> -->
    </div>

    <!-- </v-card> -->

    <div class="pa-0" style="height: 100%">
      <div class="rw-card-content">
        <!-- 洪水予報 -->
        <div v-if="this.tab == 0" class="rw-box-list">
          <!-- 読み込み中 -->
          <div v-if="isLoading === 1" class="rw-progress">
            <v-progress-circular
              v-if="isLoading === 1"
              indeterminate
              :size="30"
              :width="5"
            ></v-progress-circular>
          </div>
          <!-- 読み込み済み -->
          <div v-if="isLoading === 0">
            <v-col
              class="rw-no-regist pt-6"
              v-if="!riverWarns.fldfr || riverWarns.fldfr.length == 0"
              >{{
                this.$store.state.app.config.messageConfig.rwNoRegist
              }}</v-col
            >
            <v-list
              light
              v-for="(fldfr, fldfrIdx) in riverWarns.fldfr"
              :key="'fldfrIdx' + fldfrIdx"
              class="pa-0"
            >
              <v-list-item
                class="rw-list-item"
                @click="clickRiverWarnList(fldfr.type, fldfr.cd)"
              >
                <v-list-item-content class="rw-name">{{
                  fldfr.nm
                }}</v-list-item-content>
                <v-list-item-content class="rw-status">
                  <!-- 発令中予警報 -->
                  <span
                    v-if="fldfr.lvl == 0"
                    class="text-flood-normal rw-span-warn rw-span-normal"
                    >{{ fldfr.kndNmS }}</span
                  >

                  <span
                    v-if="fldfr.lvl == 30"
                    class="text-flood-warn rw-span-warn"
                    >{{ fldfr.kndNmS
                    }}{{ config.messageConfig.alertLvl.fldfrLvl2 }}</span
                  >
                  <span
                    v-if="fldfr.lvl == 60"
                    class="text-flood-refuge rw-span-warn"
                    >{{ fldfr.kndNmS
                    }}{{ config.messageConfig.alertLvl.fldfrLvl3 }}</span
                  >
                  <span
                    v-if="fldfr.lvl == 80"
                    class="text-flood-danger rw-span-warn"
                    >{{ fldfr.kndNmS
                    }}{{ config.messageConfig.alertLvl.fldfrLvl4 }}</span
                  >
                  <span
                    v-if="fldfr.lvl == 90"
                    class="text-flood-occurrence rw-span-warn"
                    >{{ fldfr.kndNmS
                    }}{{ config.messageConfig.alertLvl.fldfrLvl5 }}</span
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <!-- 発令日時 -->
                  <v-list-item-title class="rw-ann">
                    <div>
                      <span v-if="isNew(fldfr.annTime)" class="rw-span-new "
                        >新着</span
                      >
                      <span v-if="!isNew(fldfr.annTime)" class="rw-span-notnew "
                        >&nbsp;</span
                      >
                      {{ getDispDate(fldfr.annTime) }}
                      第{{ fldfr.annNo }}号
                    </div>
                  </v-list-item-title>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </div>
        </div>
        <!-- ダム放流通知 -->
        <div v-if="this.tab == 1" class="rw-box-list">
          <!-- 読み込み中 -->
          <div v-if="isLoading === 1" class="rw-progress">
            <v-progress-circular
              v-if="isLoading === 1"
              indeterminate
              :size="30"
              :width="5"
            ></v-progress-circular>
          </div>
          <!-- 読み込み済み -->
          <div v-if="isLoading === 0">
            <v-col
              class="rw-no-regist pt-6"
              v-if="!riverWarns.damdsch || riverWarns.damdsch.length == 0"
              >{{
                this.$store.state.app.config.messageConfig.rwNoRegist
              }}</v-col
            >
            <v-list
              class="pa-0"
              light
              v-for="(damdsch, damdschIdx) in riverWarns.damdsch"
              :key="'damdschIdx' + damdschIdx"
            >
              <v-list-item
                class="rw-list-item"
                @click="clickRiverWarnList(30, damdsch.damdschCd)"
              >
                <v-list-item-content class="rw-name">{{
                  damdsch.damdschNm
                }}</v-list-item-content>
                <v-list-item-content class="rw-status">
                  <!-- 発令中予警報 -->
                  <span
                    v-if="damdsch.damdschLvl == 70"
                    class="text-damdsch-disasteroperating rw-span-warn"
                    >{{ damdsch.damdschKndNm }}</span
                  >
                  <span
                    v-if="damdsch.damdschLvl == 50"
                    class="text-damdsch-riserving rw-span-warn"
                    >{{ damdsch.damdschKndNm }}</span
                  >
                  <span
                    v-if="damdsch.damdschLvl != 70 && damdsch.damdschLvl != 50"
                    class="rw-span-warn-normal rw-span-warn"
                    >{{ damdsch.damdschKndNm }}</span
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <!-- 発令日時 -->
                  <v-list-item-title class="rw-ann">
                    <div>
                      <span v-if="isNew(damdsch.annTime)" class="rw-span-new "
                        >新着</span
                      >
                      <span
                        v-if="!isNew(damdsch.annTime)"
                        class="rw-span-notnew "
                        >&nbsp;</span
                      >
                      {{ getDispDate(damdsch.annTime) }}
                      第{{ damdsch.annNo }}号
                    </div>
                  </v-list-item-title>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </div>
        </div>
        <!-- 水防警報 -->
        <div v-if="this.tab == 2" class="rw-box-list">
          <!-- 読み込み中 -->
          <div v-if="isLoading === 1" class="rw-progress">
            <v-progress-circular
              v-if="isLoading === 1"
              indeterminate
              :size="30"
              :width="5"
            ></v-progress-circular>
          </div>
          <!-- 読み込み済み -->
          <div v-if="isLoading === 0">
            <v-col
              class="rw-no-regist pt-6"
              v-if="!riverWarns.fldctl || riverWarns.fldctl.length == 0"
              >{{
                this.$store.state.app.config.messageConfig.rwNoRegist
              }}</v-col
            >
            <v-list
              class="pa-0"
              light
              v-for="(fldctl, fldctlIdx) in riverWarns.fldctl"
              :key="'fldctlIdx' + fldctlIdx"
            >
              <v-list-item
                class="rw-list-item"
                @click="clickRiverWarnList(20, fldctl.fldctlCd)"
              >
                <v-list-item-content class="rw-name">{{
                  fldctl.fldctlNm
                }}</v-list-item-content>
                <v-list-item-content class="rw-status">
                  <!-- 発令中予警報 -->
                  <span
                    v-if="fldctl.fldctlLvl == 0"
                    class="text-fldctl-normal rw-span-warn rw-span-normal"
                    >{{ fldctl.fldctlKndNm }}</span
                  >
                  <span
                    v-if="fldctl.fldctlLvl == 10"
                    class="text-fldctl-standby rw-span-warn"
                    >{{ fldctl.fldctlKndNm }}</span
                  >
                  <span
                    v-if="fldctl.fldctlLvl == 20"
                    class="text-fldctl-preparation rw-span-warn mb-1"
                    >{{ fldctl.fldctlKndNm }}</span
                  >
                  <span
                    v-if="fldctl.fldctlLvl == 40"
                    class="text-fldctl-dispatch rw-span-warn mb-1"
                    >{{ fldctl.fldctlKndNm }}</span
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <!-- 発令日時 -->
                  <v-list-item-title class="rw-ann">
                    <div>
                      <span v-if="isNew(fldctl.annTime)" class="rw-span-new "
                        >新着</span
                      >
                      <span
                        v-if="!isNew(fldctl.annTime)"
                        class="rw-span-notnew "
                        >&nbsp;</span
                      >
                      {{ getDispDate(fldctl.annTime) }}
                      第{{ fldctl.annNo }}号
                    </div>
                  </v-list-item-title>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
import mixin from "./../../lib/mixin.js";
import util from "./../../lib/util.js";
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "rw-list",
  mixins: [mixin],
  data() {
    return {
      tab: 0,
      /** スピナー表示[0:非表示,1:表示] */
      isLoading: 0,
    };
  },
  mounted() {
    this.$log.debug("[RwList] mounted()");
    // パラメータによって初期表示するタブを変更
    let type = this.$route.query["type"];
    if (type === "fldfr") {
      this.tab = 0;
    } else if (type === "damdsch") {
      this.tab = 1;
    } else if (type === "fldctl") {
      this.tab = 2;
    }
    this.$store.commit("app/setContent", "RiverwarnList");
    this.getRiverWarns();
  },
  computed: {
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTimeRoundRw,
          towns: this.$store.state.map.towns,
          prefs: this.$store.state.map.prefs,
          townsAcqTime: this.$store.state.map.townsAcqTime,
        };
      },
    },
    /**
     * 表示範囲の河川予警報データ
     */
    riverWarns: {
      get() {
        return this.$store.state.RiverWarn.riverWarnsList;
      },
    },
    /**
     * 水防団モード
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /**
     *  設定情報
     */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
  },
  methods: {
    /**
     * タブクリック
     */
    clickTab(index) {
      this.$log.debug("[RwList] clickTab(" + index + ")");
      this.tab = index;
      let type = "";
      let pLogNm = "";
      if (index === 0) {
        type = "fldfr";
        pLogNm = "list_ff";
      } else if (index === 1) {
        type = "damdsch";
        pLogNm = "list_dd";
      } else if (index === 2) {
        type = "fldctl";
        pLogNm = "list_fc";
      }
      // アクセスログ出力
      PageLog.log({
        page_log: pLogNm,
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      let setQuery = Object.assign({}, this.$route.query);
      setQuery.type = type;
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * 表示範囲の河川予警報一覧を取得
     */
    getRiverWarns() {
      this.$log.debug("[RwList] getRiverWarns()");
      // 河川予警報観測日時、市町村リスト取得時刻が変更された場合にAPIを取得
      if (
        new Date(this.reqParam.appTime).getTime() !=
          new Date(
            this.$store.state.RiverWarn.riverWarnsParam.dispTime
          ).getTime() ||
        new Date(this.reqParam.townsAcqTime).getTime() !=
          new Date(
            this.$store.state.RiverWarn.riverWarnsParam.townsAcqTime
          ).getTime()
      ) {
        // アクセスログ出力
        // ログ名称設定
        let pLogNm = "";
        if (this.tab == 0) pLogNm = "list_ff";
        if (this.tab == 1) pLogNm = "list_dd";
        if (this.tab == 2) pLogNm = "list_fc";
        PageLog.log({
          page_log: pLogNm,
          lat: this.$store.state.map.center[0],
          lon: this.$store.state.map.center[1],
          zm: this.$store.state.map.zoom,
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
        this.isLoading = 1;
        setTimeout(() => {
          if (this.$store.state.map.prefTownType === "pref") {
            this.$store.dispatch("RiverWarn/getRwListByPref", {
              appTime: this.reqParam.appTime,
              prefs: this.reqParam.prefs,
              townsAcqTime: this.reqParam.townsAcqTime,
            });
          } else {
            this.$store.dispatch("RiverWarn/getRwListByTwn", {
              appTime: this.reqParam.appTime,
              prefs: this.reqParam.prefs,
              towns: this.reqParam.towns,
              townsAcqTime: this.reqParam.townsAcqTime,
            });
          }
        }, 500);
      }
    },
    /**
     * 予警報行クリック時
     */
    clickRiverWarnList(type, cd) {
      this.$log.debug("[RwList] clickRiverWarnList(" + type + "," + cd + ")");
      switch (type) {
        case "fldfr":
          type = 10;
          this.$log.debug("[RwList] clickRiverWarnList type = 10");
          break;
        case "evstg":
          type = 11;
          this.$log.debug("[RwList] clickRiverWarnList type = 11");
          break;
      }
      // ストアに区間コード、予警報タイプを設定
      this.$store.commit("RiverWarn/setSelectedWarnReq", {
        type: type,
        cd: cd,
      });
      // 河川予警報画面に遷移
      this.routerPushRw("/mb/rwdetail");
    },
    /**
     * 表示時刻時刻取得
     */
    getDispDate(annTime) {
      this.$log.debug("[RwList] getDispDate(" + annTime + ")");
      return util.formatDate24(annTime, "MM/DD HH:mm");
    },
    /**
     * 新着アイコン表示有無を取得
     */
    isNew(annTime) {
      this.$log.debug("[RwList] isNew(" + annTime + ")");
      let time = util.toDate(annTime);
      let addTime = util.addDate(
        time,
        0,
        this.$store.state.app.config.riverWarnConfig.isNewTime,
        0
      );
      if (this.$store.state.app.appTime < addTime) {
        this.$log.debug("[RwList] isNew = true");
        return true;
      } else {
        this.$log.debug("[RwList] isNew = false");
        return false;
      }
    },
    /**
     * 予警報種別ボタン点滅
     */
    rwBtnStates(idx) {
      this.$log.debug("[RwList] rwBtnStates(" + idx + ")");
      // 選択中の予警報
      if (idx === this.tab) {
        return "com-btn-on";
        // 選択していない予警報で発令中の場合に点滅
      } else if (
        idx === 0 &&
        this.riverWarns.fldfr &&
        this.riverWarns.fldfr.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 1 &&
        this.riverWarns.damdsch &&
        this.riverWarns.damdsch.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 2 &&
        this.riverWarns.fldctl &&
        this.riverWarns.fldctl.length > 0
      ) {
        return "com-btn-flash";
      }
    },
  },
  watch: {
    /**
     * リクエストパラメータ変更時
     */
    reqParam() {
      this.$log.debug("[RwList] watch(reqParam)");
      this.getRiverWarns();
    },
    /**
     * 表示範囲の河川予警報データ
     */
    riverWarns() {
      this.$log.debug("[RwList] watch(riverWarns)");
      this.isLoading = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../scss/kwb.scss";

.rw-tab-btn {
  height: 40px;
  .rw-tab-item {
    padding: 0 0px;
    margin: 6px 0 0 6px;
    margin: 6px 0 0 6px;
    height: 30px;
    width: 20px;
    font-size: 0.5rem;
  }
}

.rw-header {
  display: flex;
  align-items: center;
}

.rw-list {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.rw-ov-icon {
  min-width: 22px;
}

.rw-list-item {
  .rw-name {
    font-size: 0.7rem;
  }

  .rw-status {
    display: inline;
    .rw-span-warn {
      font-size: 0.6rem;
      display: inline-block;
      padding: 4px 4px 4px 4px;
      border-radius: 4px;
    }

    .rw-span-normal {
      border: solid 1px black;
    }
  }

  .rw-ann {
    font-size: 0.7rem;

    .rw-span-new {
      display: inline-block;
      width: 28px;
      font-size: 0.5rem;
      text-align: center;

      padding: 2px 2px 2px 2px;
      border-radius: 4px;
      background-color: $color-newcome;
      color: white;
    }
    .rw-span-notnew {
      width: 28px;
      display: inline-block;
      padding: 2px 2px 2px 2px;
      background-color: white;
    }
  }
}

.rw-card-content {
  position: relative;
  height: 100%;
}
.rw-box-list {
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow: auto;
  .rw-no-regist {
    font-size: 0.9rem;
  }
}

.rw-span-warn-normal {
  font-size: 10pt;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border-radius: 4px;
  border: solid 1px black;
}

.rw-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
